import { serializable, alias, primitive } from 'serializr';

export class Statuses {
	@serializable(alias('id', primitive()))
	id?: string;

	@serializable(alias('name', primitive()))
	name?: string;
}
